import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
import { demoPhone } from '../../data/websites';
import { LiveChangeDemo } from './LiveChangeDemo';
export function WebsitesHero() {
  return <section className="overflow-hidden bg-white px-[clamp(1rem,4vw,6rem)] pb-20 pt-14 lg:pb-28 lg:pt-20" data-id="element-959" data-mp="1ck6ryrfarzt2">
      <div className="grid items-center gap-14 lg:grid-cols-2 xl:gap-20" data-id="element-960" data-mp="1hd9on8fdfpdh">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-961" data-mp="1mbjmxrwe763b">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-962" data-mp="1vay94f5j0ui0">Websites That Run Themselves</p>
          <h1 className="mt-5 max-w-[18ch] text-[clamp(2.5rem,4.4vw,5.5rem)] font-extrabold leading-[1.04] tracking-tight text-brand-black" data-id="element-963" data-mp="20asxaaxx35zd">
            Your website, changed in minutes. <span className="text-brand-red" data-id="element-964" data-mp="5w9us8ddl2hc">Just say what you want.</span>
          </h1>
          <p className="mt-6 max-w-[60ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-600" data-id="element-965" data-mp="3ei87vyc7gqb3">
            Tell us the change the way you’d tell a person: by phone, text, email, Slack or online. It’s live on your real
            website within minutes, and we check your live site before we tell you it’s done.
          </p>
          <div className="mt-9 flex flex-col gap-4 sm:flex-row" data-id="element-966" data-mp="30s4qpls6nmsi">
            <a href={demoPhone.tel} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-brand-red px-8 py-4 text-lg font-bold text-white shadow-lg transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-967" data-mp="1bgb2jwvygqs">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-968" data-mp="2d190gt3dkznd" />
              Try it now: {demoPhone.display}
            </a>
            <a href="#/contact" className="inline-flex items-center justify-center whitespace-nowrap rounded-md border-2 border-gray-200 bg-white px-8 py-4 text-lg font-bold text-gray-700 transition-colors duration-150 ease-out hover:border-brand-black hover:text-brand-black focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-969" data-mp="281wfkdw2e2nf">
              Talk to us
            </a>
          </div>
          <p className="mt-6 text-sm font-medium text-brand-gray" data-id="element-970" data-mp="1qstu7iji7mtl">
            No web designer needed. No waiting days. No bill for every little edit.
          </p>
        </motion.div>

        <LiveChangeDemo data-id="element-971" data-mp="1vldcgst4z64q" />
      </div>
    </section>;
}